/* global SideDrawer */

document.addEventListener('DOMContentLoaded', () => {
  const openButton = document.querySelector('.open-availability-drawer');

  if (openButton) {
    openButton.addEventListener('click', () => {
      const event = new CustomEvent('dispatch:availability-drawer:open', {
        detail: {
          opener: openButton // Optional, can be used if you need to know which element opened the drawer
        }
      });
      document.dispatchEvent(event);
    });
  }
});


class AvailabilityDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:availability-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:availability-drawer:close', this.closeDrawerViaEventHandler);
    this.addEventListener('on:availability-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:availability-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:availability-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }
}

window.customElements.define('availability-drawer', AvailabilityDrawer);

